import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Button, Checkbox, FormControlLabel } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { DetailedStreetFinder } from '../../general/DetailedStreetFinder';
import { useFormik } from 'formik';
import { addressSchema } from 'src/utils/formValidation/yupValidators';
export const RequestToUseCustomAddressContentWithoutCallback = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    data = _ref.data;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const defaultPropertyAddress = data ? data.details : {};
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    handleStartValidate = _useState2[0],
    setHandleStartValidate = _useState2[1];
  const _useState3 = useState(data ? data.isPrimary : false),
    _useState4 = _slicedToArray(_useState3, 2),
    isChecked = _useState4[0],
    setIsChecked = _useState4[1];
  const formik = useFormik({
    initialValues: {
      address: ''
    },
    validationSchema: addressSchema,
    onSubmit: async () => {
      setHandleStartValidate(true);
    }
  });
  const handleStartSubmitting = async resultId => {
    const details = await store.address.batchGetAddressesAsync.run({
      addressIds: [resultId]
    });
    if (data) {
      store.residencies.setCustomAddress({
        isPrimary: isChecked,
        addressId: resultId,
        details: details.response[0]
      });
    } else {
      store.residencies.addNewCustomAddress({
        isPrimary: isChecked,
        addressId: resultId,
        details: details.response[0]
      });
    }
    toast('success', {
      body: ['Successfully saved']
    });
    handleModalClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.streetFinder
  }, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    name: "address",
    validator: formik,
    error: !!formik.errors.address,
    helperText: t(formik.errors.address, t),
    defaultPropertyAddress: defaultPropertyAddress
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.conditionWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.conditionForm
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isChecked,
      onChange: () => setIsChecked(!isChecked)
    }),
    label: /*#__PURE__*/React.createElement("b", null, t('Use as primary mailing address'))
  }))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '365-RequestToUseCustomAddressContent'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: formik.handleSubmit,
    disabled: !formik.values.address,
    'custom-attribute': '366-RequestToUseCustomAddressContent'
  }, data ? 'Save' : t('Add address')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.address.addNewAddressAsync.inProgress || store.address.updateAddressAsync.inProgress || store.address.batchGetAddressesAsync.inProgress || store.residencies.addResidencyAddressAsync.inProgress || store.residencies.getResidencyAddressesAsync.inProgress || store.residencies.updateResidencyAddressAsync.inProgress || store.residencies.updateResidencyAddressStatusAsync.inProgress || store.residencies.setAllCustomPrimaryAddressesToSecondaryAsync.inProgress
  }));
});